import React from 'react';
import { UrlMatcher } from '@kyruus/rich-text/Renderer';
import { CustomXPFieldConfig, ProviderMatchProviderV9 } from '@kyruus/types';

import CardContainer from '../CardContainer/card-container';
import { extractProviderDataContent } from '../../lib/utils';
import { AboutContentText } from '../ProviderAbout/styles';
import { CustomXPFieldsHeader, CustomXPFieldsContent } from './styles';

type CustomXPFieldRendererProps = {
  customXPFieldConfig: CustomXPFieldConfig;
  provider: ProviderMatchProviderV9;
  autolink?: {
    enabled?: boolean;
    customTLDs?: string[];
  };
};
export const CustomXPFieldRenderer = ({
  customXPFieldConfig,
  provider,
  autolink: { enabled = true, customTLDs = [] } = {}
}: CustomXPFieldRendererProps) => {
  const content = extractProviderDataContent(
    { field: customXPFieldConfig.field },
    provider as unknown as Record<string, unknown>
  );
  if (content) {
    return (
      <CardContainer>
        <CustomXPFieldsHeader>{customXPFieldConfig.title}</CustomXPFieldsHeader>
        <CustomXPFieldsContent>
          {/* reuse the renderer from the About sections since we want the same logic here */}
          <AboutContentText
            content={content.toString()}
            data-testid={`custom-xp-field-${customXPFieldConfig.field}-content`}
            disableDefaultMatchers={true}
            matchers={enabled ? [new UrlMatcher('url', { customTLDs })] : []}
            newWindow={true}
            tagName={
              customXPFieldConfig.field_type === 'rich_text' ? 'div' : 'p'
            }
          />
        </CustomXPFieldsContent>
      </CardContainer>
    );
  }
  return null;
};
